var _g, _g2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgY3PointerMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.8,
    height: 52,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Polygon 1",
    fill: "#3086ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3 6.798v38.404a3.468 3.468 0 01-1.725 3.016 3.468 3.468 0 01-3.475.043L6.537 29.06a3.457 3.457 0 01-1.8-3.06c0-1.29.672-2.433 1.8-3.06L41.1 3.74a3.468 3.468 0 013.475.043A3.468 3.468 0 0146.3 6.798z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.236 26c0 1.105.577 2.086 1.544 2.622l34.563 19.202c.94.522 2.053.508 2.978-.036a2.973 2.973 0 001.479-2.586V6.798c0-1.074-.553-2.04-1.479-2.586a2.973 2.973 0 00-2.978-.036L6.78 23.378A2.963 2.963 0 005.236 26m-1 0a3.96 3.96 0 012.058-3.497L40.857 3.301c2.667-1.48 5.943.447 5.943 3.497v38.404c0 3.05-3.276 4.978-5.943 3.497L6.294 29.497A3.96 3.96 0 014.236 26z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 103",
    transform: "translate(18.4 13)",
    fill: "#fff",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "none"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(31.4 34)",
    fill: "#3086ff",
    fontSize: 22,
    fontFamily: "Helvetica"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.118,
    y: 0
  }, "3"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgY3PointerMark);
export default __webpack_public_path__ + "static/media/Y3PointerMark.ab46590aad419ea7.svg";
export { ForwardRef as ReactComponent };